var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link } from '../../../../../atoms/link';
import { Text, TextHtmlTags, TextHyphens, TextVariants } from '../../../../../atoms/text';
var PCN = function (_a) {
    var productName = _a.productName, linkUrl = _a.linkUrl, restProps = __rest(_a, ["productName", "linkUrl"]);
    var nameConfig = {
        content: productName,
        component: TextHtmlTags.H2,
        variant: TextVariants.H5,
        hyphens: TextHyphens.None
    };
    var linkProps = __assign({ linkUrl: linkUrl }, restProps);
    if (!productName) {
        return null;
    }
    return linkUrl ? (React.createElement(Link, __assign({}, linkProps),
        React.createElement(Text, __assign({}, nameConfig)))) : (React.createElement(Text, __assign({}, nameConfig)));
};
export { PCN as ProductCardName };
